import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import parse from 'html-react-parser';




export class CampaignPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false

        };

        this.toggleModal = this.toggleModal.bind(this);

    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    render() {

        return (
            <Modal size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle} >
                <ModalHeader toggle={this.props.toggle}>Campaign Message</ModalHeader>
                <ModalBody>
                    <div className="campaignPreview-Content" >
                        {parse(this.props.message.MessageBody)}
                    </div>


                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" className="btn btn-rounded" onClick={this.props.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )

    }
}
